import get from '@invitato/helpers/dist/getLocale';

export default {
  textAyat: get(
    '“Kutemui jantung hatiku.”', 
    '“Kutemui jantung hatiku.”'
  ),
  ayatName: get('(Kidung Agung 3:4)', '(Kidung Agung 3:4)'),
};